export const compare = (a: any, b: any, property: string, isAsc?: number) => {
    if (isAsc) {
        return isAsc === 1 ? orderGrowing(a, b, property) : orderDecreasing(a, b, property);
    }

    return orderGrowing(a, b, property);
}

const orderGrowing = (a: any, b: any, property: string,) => {
    if (a[property] > b[property]) {
        return 1;
    }
    if (a[property] < b[property]) {
        return -1;
    }
    // a must be equal to b
    return 0;
}

const orderDecreasing = (a: any, b: any, property: string,) => {
    if (a[property] > b[property]) {
        return -1;
    }
    if (a[property] < b[property]) {
        return 1;
    }
    // a must be equal to b
    return 0;
}